/**
 * A switch statement in function form. Useful for `switch`ing in a JSX template.
 *
 * Takes a value and returns the value of the options key with a matching value.
 * Falls back to a 'default' key from the options object if it exists.
 *
 * If the value is a function, the function will be called and that function's return value
 * will be returned from this function.
 *
 * @param {any} value - The value to match.
 * @param {Object | Function} options - An options object with keys matching potential values.
 */
export default function (value, options) {
  const selection = options[value] || options["default"];

  if (typeof selection === "function") {
    return selection();
  } else {
    return selection;
  }
}
